export default __webpack_public_path__ + "static/media/bg.bf452ec3.png";